interface Props {
  counts: { pending: number; published: number; rejected: number; total: number };
  onScrape: () => void;
  scraping: boolean;
  lastScrape: string | null;
  onFillUrls?: () => void;
  fillingUrls?: boolean;
}

export default function AdminStatsBar({ counts, onScrape, scraping, lastScrape, onFillUrls, fillingUrls }: Props) {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
      <div className="bg-white rounded-2xl p-5 border border-gray-100">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-9 h-9 flex items-center justify-center rounded-xl bg-gray-100">
            <i className="ri-article-line text-gray-600"></i>
          </div>
          <span className="text-sm text-gray-500 font-medium">Total articles</span>
        </div>
        <p className="text-3xl font-bold text-gray-900">{counts.total}</p>
      </div>

      <div className="bg-white rounded-2xl p-5 border border-amber-100">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-9 h-9 flex items-center justify-center rounded-xl bg-amber-50">
            <i className="ri-time-line text-amber-500"></i>
          </div>
          <span className="text-sm text-amber-600 font-medium">En attente</span>
        </div>
        <p className="text-3xl font-bold text-amber-600">{counts.pending}</p>
      </div>

      <div className="bg-white rounded-2xl p-5 border border-green-100">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-9 h-9 flex items-center justify-center rounded-xl bg-green-50">
            <i className="ri-checkbox-circle-line text-green-500"></i>
          </div>
          <span className="text-sm text-green-600 font-medium">Publiés</span>
        </div>
        <p className="text-3xl font-bold text-green-600">{counts.published}</p>
      </div>

      <div className="bg-white rounded-2xl p-5 border border-red-100">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-9 h-9 flex items-center justify-center rounded-xl bg-red-50">
            <i className="ri-close-circle-line text-red-500"></i>
          </div>
          <span className="text-sm text-red-500 font-medium">Rejetés</span>
        </div>
        <p className="text-3xl font-bold text-red-500">{counts.rejected}</p>
      </div>

      <div className="col-span-2 lg:col-span-4 bg-gradient-to-r from-gray-900 to-gray-800 rounded-2xl p-5 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        <div>
          <p className="text-white font-semibold text-sm mb-1">Outils automatiques</p>
          <p className="text-gray-400 text-xs">
            {lastScrape ? `Dernier scraping : ${lastScrape}` : "Complétez les URLs manquantes ou lancez un scraping RSS"}
          </p>
        </div>
        <div className="flex flex-wrap gap-3">
          {onFillUrls && (
            <button
              onClick={onFillUrls}
              disabled={fillingUrls}
              className="flex items-center gap-2 bg-orange-400 hover:bg-orange-500 disabled:opacity-60 text-white font-semibold px-5 py-2.5 rounded-full transition-colors cursor-pointer whitespace-nowrap text-sm"
            >
              {fillingUrls ? (
                <><i className="ri-loader-4-line animate-spin"></i>Recherche URLs...</>
              ) : (
                <><i className="ri-magic-line"></i>Compléter les URLs auto</>
              )}
            </button>
          )}
          <button
            onClick={onScrape}
            disabled={scraping}
            className="flex items-center gap-2 bg-white/10 hover:bg-white/20 disabled:opacity-60 text-white font-semibold px-5 py-2.5 rounded-full transition-colors cursor-pointer whitespace-nowrap text-sm"
          >
            {scraping ? (
              <><i className="ri-loader-4-line animate-spin"></i>Scraping...</>
            ) : (
              <><i className="ri-refresh-line"></i>Scraping RSS</>
            )}
          </button>
        </div>
      </div>
    </div>
  );
}
